import { Inject, Injectable } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { Store } from '@ngrx/store';
import { CommonActions } from './store';

@Injectable()
export class Constants {
    public appVersion = '4.0.0';
    public debugMode = 0;
    static apiKey = '';
    public apiUrl = '';

    constructor(
        @Inject(APP_BASE_HREF) private baseHref: string,
        private store: Store
    ) {
        this.apiUrl = this.baseHref + 'api';
        this.store.dispatch(
            CommonActions.loadConstants({
                constants: {
                    appVersion: this.appVersion,
                    debugMode: this.debugMode,
                    apiKey: Constants.apiKey,
                    apiUrl: this.apiUrl,
                },
            })
        );
    }
}
